import Widget from "components/widget/Widget";
import ComplexTable from "./components/ComplexTable";
import { MdAdd } from "react-icons/md";
import useSWR from "swr";
import { adminAPI } from "services/admin";
import { AdminForm } from "./components/AdminForm";

const ProfileOverview = () => {
  const {
    data,
    isLoading,
    mutate,
  } = useSWR(`/admins`, () => adminAPI.getAdmins());

  return (
    <div className="mt-3">
      <div className="grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-3 3xl:grid-cols-3">
        <AdminForm admins={data?.data} onSuccess={() => mutate()}>
          <button className="rounded-2xl outline-none">
            <Widget
              icon={<MdAdd className="h-7 w-7" />}
              title={""}
              subtitle={"Add new admin"}
            />
          </button>
        </AdminForm>
      </div>
      <div className="mt-3 grid h-full grid-cols-1 gap-4">
        <ComplexTable
          tableData={data?.data ? data.data : []}
          isLoading={isLoading}
          onSuccess={() => mutate()}
        />
      </div>
    </div>
  );
};

export default ProfileOverview;
